import NestedForm from "@stimulus-components/rails-nested-form"

export default class extends NestedForm {
  static values = {
    minNumberItems: Number,
    maxNumberItems: Number,
  }

  connect() {
    super.connect()
    this.updateButtonsVisibility()
  }

  add(event) {
    super.add(event)

    setTimeout(() => this.updateButtonsVisibility(), 0)
  }

  remove(event) {
    super.remove(event)

    setTimeout(() => this.updateButtonsVisibility(), 0)
  }

  get wrappers() {
    const selector = this.wrapperSelectorValue || ".nested-form-wrapper"
    return Array.from(this.element.querySelectorAll(selector))
  }

  updateButtonsVisibility() {
    const count = this.wrappers.length

    const addButtons = this.element.querySelectorAll('[data-action~="nested-form#add"]')
    if (this.hasMaxNumberItemsValue && count >= this.maxNumberItemsValue) {
      addButtons.forEach((btn) => btn.classList.add("hidden"))
    } else {
      addButtons.forEach((btn) => btn.classList.remove("hidden"))
    }

    const removeButtons = this.element.querySelectorAll('[data-action~="nested-form#remove"]')
    if (this.hasMinNumberItemsValue && count <= this.minNumberItemsValue) {
      removeButtons.forEach((btn) => btn.classList.add("hidden"))
    } else {
      removeButtons.forEach((btn) => btn.classList.remove("hidden"))
    }
  }

  scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight)
  }
}
